import Dropzone from "dropzone";
import { Controller } from "@hotwired/stimulus";
import { DirectUpload } from "@rails/activestorage";

export default class extends Controller {
  static targets = ["input"];

  connect() {
    this.dropZone = this.createDropZone();
    this.hideFileInput();
    this.bindEvents();
    Dropzone.autoDiscover = false;
  }

  hideFileInput() {
    this.inputTarget.disabled = true;
    this.inputTarget.style.display = "none";
  }

  bindEvents() {
    this.dropZone.on("addedfile", file => {
      // Verificar si ya existe un archivo con el mismo nombre
      const existingFile = this.dropZone.files
        .filter(f => f !== file)
        .find(f => f.name === file.name);
      
      if (existingFile) {
        this.dropZone.removeFile(file);
        alert('Ya existe un archivo con el mismo nombre');
        return;
      }

      setTimeout(() => {
        if (file.accepted) {
          new DirectUploadController(this, file).start();
        }
      }, 500);
    });

    this.dropZone.on("removedfile", file => {
      if (file.controller) file.controller.hiddenInput.remove();
    });

    this.dropZone.on("canceled", file => {
      if (file.controller) file.controller.xhr.abort();
    });

    this.dropZone.on("success", (file) => {
      file.status = Dropzone.SUCCESS;
      file.previewElement.classList.add("dz-success");
      this.dropZone.emit("complete", file);
    });

    this.dropZone.on("error", (file, errorMessage) => {
      file.status = Dropzone.ERROR;
      file.previewElement.classList.add("dz-error");
      this.dropZone.emit("complete", file);
    });
  }

  createDropZone() {
    const config = {
      url: this.inputTarget.getAttribute("data-direct-upload-url"),
      headers: { 
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content,
        // Agregar headers CORS necesarios
        "Access-Control-Allow-Origin": "*", // O especifica el dominio exacto
        "Access-Control-Allow-Methods": "POST, PUT, DELETE, GET, OPTIONS",
        "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept, Authorization",
        "Access-Control-Allow-Credentials": "true"
      },
      autoQueue: false,
      addRemoveLinks: true,
      dictDefaultMessage: this.element.dataset.dropzoneDefaultMessage,
      dictFallbackMessage: this.element.dataset.dropzoneFallbackMessage,
      dictFallbackText: this.element.dataset.dropzoneFallbackText,
      dictFileTooBig: this.element.dataset.dropzoneFileTooBig,
      dictInvalidFileType: this.element.dataset.dropzoneInvalidFileType,
      dictResponseError: this.element.dataset.dropzoneResponseError,
      dictCancelUpload: this.element.dataset.dropzoneCancelUpload,
      dictCancelUploadConfirmation: this.element.dataset.dropzoneCancelUploadConfirmation,
      dictRemoveFile: this.element.dataset.dropzoneRemoveFile,
      dictMaxFilesExceeded: this.element.dataset.dropzoneMaxFilesExceeded,
      dictUploadCanceled: this.element.dataset.dropzoneUploadCanceled
    };

    if (this.element.dataset.dropzoneMaxFiles) {
      config.maxFiles = parseInt(this.element.dataset.dropzoneMaxFiles);
    }
    if (this.element.dataset.dropzoneMaxFileSize) {
      config.maxFilesize = parseInt(this.element.dataset.dropzoneMaxFileSize);
    }
    if (this.element.dataset.dropzoneAcceptedFiles) {
      config.acceptedFiles = this.element.dataset.dropzoneAcceptedFiles;
    }

    return new Dropzone(this.element, config);
  }
}

class DirectUploadController {
  constructor(source, file) {
    this.directUpload = new DirectUpload(file, source.inputTarget.getAttribute("data-direct-upload-url"), this);
    this.source = source;
    this.file = file;
  }

  start() {
    this.file.controller = this;
    this.hiddenInput = this.createHiddenInput();
    this.directUpload.create((error, attributes) => {
      if (error) {
        this.file.status = Dropzone.ERROR;
        this.source.dropZone.emit("error", this.file, error);
        this.hiddenInput.remove();
      } else {
        this.hiddenInput.value = attributes.signed_id;
        this.file.status = Dropzone.SUCCESS;
        this.source.dropZone.emit("success", this.file);
      }
      this.source.dropZone.emit("complete", this.file);
    });
  }

  createHiddenInput() {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = this.source.inputTarget.name;
    this.source.inputTarget.parentNode.insertBefore(input, this.source.inputTarget.nextSibling);
    return input;
  }
}
